import React from 'react'
import { LPMachineLogicPlansSection } from '../../api/Types'
import LandingPageSectionWrapper from '../common/LandingPageSectionWrapper'
import I18n from '../../../../helpers/I18n'
import { useCurrencyContext } from '../../../common/providers/CurrencyProvider'
import Currency, { currencyCb } from '../../../common/Currency'

type Props = LPMachineLogicPlansSection

const GridItem = ({ title, description, per_machine, buttonUrl }) => (
  <div className='machine-logic-plans-section-grid-item'>
    <h3 className='machine-logic-plans-section-grid-item-title'>{title}</h3>
    <div className='machine-logic-plans-section-grid-item-description'>
      <div className='machine-logic-plans-section-grid-item-description-text'>
        {description}
        {per_machine && (
          <span className='machine-logic-plans-per-machine'>
            ({I18n.t('views.cms.landing_pages.machine_logic_plans.unit_text')})
          </span>
        )}
      </div>
      <a href={buttonUrl} className='machine-logic-plans-section-grid-item-description-button'>
        {I18n.t('views.cms.landing_pages.machine_logic_plans.button_text')}
      </a>
    </div>
  </div>
)

const LandingPageMachineLogicPlans: React.FunctionComponent<Props> = ({ style }) => {
  const { currentExchangeRate, convertPriceFromBase } = useCurrencyContext()

  const exchangeRate = currentExchangeRate()

  const gridItems = [
    {
      title: I18n.t('views.cms.landing_pages.machine_logic_plans.plans.free.title'),
      description: I18n.t('views.cms.landing_pages.machine_logic_plans.plans.free.description'),
      per_machine: false,
      buttonUrl: '/machine-logic-subscriptions#trial-plan',
    },
    {
      title: I18n.t('views.cms.landing_pages.machine_logic_plans.plans.basic.title'),
      description: exchangeRate ? (
        <>
          <Currency
            symbol={exchangeRate.currency_symbol}
            currencyCb={currencyCb(convertPriceFromBase(1200) as number, { precision: 0 })}
          />{' '}
          / {I18n.t('views.cms.landing_pages.machine_logic_plans.subscription_length')}
        </>
      ) : (
        ''
      ),
      per_machine: true,
      buttonUrl: '/machine-logic-subscriptions#machine-logic-basic-plan',
    },
    {
      title: I18n.t('views.cms.landing_pages.machine_logic_plans.plans.robot.title'),
      description: exchangeRate ? (
        <>
          <Currency
            symbol={exchangeRate.currency_symbol}
            currencyCb={currencyCb(convertPriceFromBase(3000) as number, { precision: 0 })}
          />{' '}
          / {I18n.t('views.cms.landing_pages.machine_logic_plans.subscription_length')}
        </>
      ) : (
        ''
      ),
      per_machine: true,
      buttonUrl: '/machine-logic-subscriptions#machine-logic-with-robot-plan',
    },
  ]

  return (
    <LandingPageSectionWrapper cssNamespace='machine-logic-plans-section' style={style}>
      <h2 className='machine-logic-plans-section-title'>
        {I18n.t('views.cms.landing_pages.machine_logic_plans.title')}
      </h2>
      <div className='machine-logic-plans-section-grid'>
        {gridItems.map((gridItem, index) => (
          <GridItem key={index} {...gridItem} />
        ))}
      </div>
    </LandingPageSectionWrapper>
  )
}

export default LandingPageMachineLogicPlans
